export default {
  updateSidebarState (state) {
    state.isOpen = !state.isOpen;
  }
}



// WEBPACK FOOTER //
// ./app/resource/global/store/mutations.js